<template>
    <div class="content">
        <el-row :gutter="20">
            <el-col :span="17">
                
                <el-form ref="form" :model="form" class="flxz">
                  <el-col :span="23">
                    <el-form-item label="" label-width="10px">
                      <p style="font-size:16px;color:#000; line-height:26px;">参考样本：</p>
                      <p style="font-size:16px;color:#000; line-height:26px;">当事人的委托代理人来本机关接受询问调查，并提供了当事人的《营业执照》、《卫生许可证》、法定代表人和代理人身份证、授权委托书等证明材料。</p>
                    </el-form-item>
                    </el-col>
                    <el-col :span="23">
                    <el-form-item label="询问描述" label-width="80px">
                      <p style="background:#f4f4f4;">&nbsp;询问日期:{{text}}</p>
                      <el-input type="textarea" :rows="10" placeholder="" v-model="form.content" :style="{width:'100%'}" @input="renew($event)"></el-input>
                    </el-form-item>
                    </el-col>
                    <el-col :span="23">
                    <el-form-item size="large" label-width="0" style="text-align:center;">
                        <el-button type="primary" @click="submit">确定</el-button>
                        <el-button type="danger" @click="cancel">取消</el-button>
                    </el-form-item>
                    </el-col>
                </el-form>
            </el-col>
            <el-col :span="7">
              <ul class="zfmb">
                <li v-for="(item,index) in zfmbList" :key="index">
                  <p @click="getActive(index)"><i :class="isActive == index?'icon2':'icon1'" style="color:#ffaf47;"></i><b>{{item.zylbMc}}</b></p>
                  <div v-show="isActive == index" class="zfmb2">
                    <span v-for="(itema,i) in item.info" :key="i" :class="isActive2 == i?'dqSpan':''" @click="getXunwennr(itema,i)">{{itema.mcjianxie}}</span>
                  </div>
                </li>
              </ul>
          
            </el-col>
        </el-row>
        
    </div>
</template>

<script>
import axios from 'axios'
import qs from 'qs'
    export default {
      components: {},
      props: ['text'],
      data() {
        return {
          form:{
            content:'',
          },
          isActive:'-1',
          isActive2:'-1',
          zfmbList:[],
          baseUrl:''
        }
      },
      watch:{
        text(){
          this.form.content = ''
          this.isActive2 = '-1'
        }
      },
      created() {
        
      },
      mounted() {
        let user = JSON.parse(sessionStorage.getItem("userdata"));
        this.baseUrl = user.baseUrl
        axios({
            method: 'post',
            url: this.baseUrl+`/login/getFalv`,
            headers: { // 添加请求头
                "Content-Type": "application/json" // 明确声明为 JSON 格式
            },
            data: {}
        })
        .then(response => {
          this.options =  response.data.data || []
        })
        .catch(error => {
            console.error('There was an error!', error);
        });
        this.getList();
      },
      methods: {
        getList(){
          axios({
                method: 'post',
                url: this.baseUrl+`/login/getZfmb`,
                headers: { // 添加请求头
                    "Content-Type": "application/json" // 明确声明为 JSON 格式
                },
                data: {
                    leibie:'调查询问过程描述',
                    find:''
                }
            })
            .then(response => {
                this.zfmbList = response.data.data || []
            })
            .catch(error => {
                console.error('There was an error!', error);
            });
        },
        renew(e){
          this.$forceUpdate()
        },
        submit(){
          this.$emit("handleBackXunwen",this.form.content)
        },
        cancel(){
          this.$emit("xunwenTk",false)
        },

        getActive(index){
          if(this.isActive == index){
            this.isActive = '-1'
          }else{
            this.isActive = index
          }
        },
        getXunwennr(itema,i){
          this.isActive2 = i
          if(this.form.content.indexOf(itema.mc) != '-1'){
            this.$message.error('不能重复添加')
          }else{
            this.form.content = this.form.content ? this.form.content + itema.mc : itema.mc
          }
        },
      }
    }
</script>

<style>
.zfmb{ border:1px solid #DCDFE6; padding: 20px;}
.zfmb li{line-height: 40px;}
.zfmb li p i{ width: 22px; height: 20px;float: left;; margin:10px 7px 0 0;}
.zfmb li p b{ cursor: pointer;}
.icon1{ background: url(../../../assets/images/wjjm.png);}
.icon2{ background: url(../../../assets/images/wjjm-a.png);}
.zfmb2{width: 100%;}
.zfmb2 span{ cursor: pointer; display: block; padding-left: 30px; background: url(../../../assets/images/wjj.png) no-repeat center left; margin-left: 30px;}
.zfmb2 span.dqSpan{color:#0C80E8;}

</style>

<style scoped>
.el-form >>> .el-textarea.is-disabled .el-textarea__inner { color: #333 !important;}
</style>